import React, { useState, useEffect } from "react";
import "../../Css/Mochitimes.css";
import { Link } from "react-router-dom";
function Mochitimes() {
  const [files, setFiles] = useState([]);
  const [baseUrl, setBaseUrl] = useState("");

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        const response = await fetch(
          "https://api.gkaglobal.org/restgka/admin/mochitimes.php"
        );
        const data = await response.json();

        if (data.status === "success") {
          

          // Store base URL
          setBaseUrl(data.baseurl);

          // Create a mapping of image files
          let imageMap = {};
          data.image_files.forEach((imageFile) => {
            const imageNameWithoutExt = imageFile
              .split(".")
              .slice(0, -1)
              .join(".");
            imageMap[imageNameWithoutExt] = data.baseurl + imageFile;
          });

          // Process PDF files
          const pdfFiles = data.pdf_files.map((fileUrl) => {
            const fileNameWithoutExt = fileUrl
              .split(".")
              .slice(0, -1)
              .join(".");
            return {
              pdfUrl: data.baseurl + fileUrl,
              imageUrl: imageMap[fileNameWithoutExt] || "",
              fileName: fileNameWithoutExt,
            };
          });

          setFiles(pdfFiles);
        } else {
          console.error("Error:", data.message);
        }
      } catch (error) {
        console.error("Failed to retrieve files:", error);
      }
    };

    fetchFiles();
  }, [baseUrl]);

  return (
    <>
      <div className="mochitimes-container">
        <div className="mochitimes-box">
          <h2 className="h3">Mochi Times</h2>

          <div id="file-list2">
            {files.length > 0 ? (
              files.map((file, index) => (
                <div className="file-item2" key={index}>
                  {file.imageUrl && (
                    <img
                      src={file.imageUrl}
                      alt="Manav Seva"
                      width="200"
                      height="200"
                    />
                  )}
                  <p className="mochi">
                    <Link
                      to={file.pdfUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {file.fileName}
                    </Link>
                  </p>
                </div>
              ))
            ) : (
              <p>No PDF files found.</p>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Mochitimes;
